import React from 'react';

const Terms = () => {
    return (
        <div className="px-8 py-10 mt-20 font-basefont">
            <h1 className="text-4xl text-center font-semibold mb-4 border-b pb-4">
                Terms & Conditions
            </h1>
            <div className="max-w-3xl mx-auto mt-8 space-y-6 text-lg leading-relaxed text-gray-800">
                <h2 className="text-2xl font-semibold">Website Disclaimer</h2>
                <p>
                    The images and text contained within this website and online catalogue are
                    intended to provide information about products offered by Weaving Hand.
                    The website does not and is not intended to enable the buying or selling
                    of products online or otherwise engage in e-commerce. Please get in touch
                    with us using the email address or phone number provided in the{' '}
                    page in case you wish to enquire about any of the products listed on this website.
                </p>
                <p>
                    All trademarks, logos, designs, images, graphics, product names, with
                    or without trademark logo, code, look-and-feel of the website and other
                    content displayed or made available on the website (“Content”) constitutes
                    intellectual property owned by Weaving Hand or its licensors.
                    You may not copy, publish, distribute, modify, edit, re-use, disseminate,
                    create derivative works from, duplicate or otherwise use any such Content
                    without our prior consent and authorisation.
                </p>
            </div>
        </div>
    );
};

export default Terms;
